import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss'],
  standalone: false
})
export class PaymentSuccessComponent implements OnInit {

  formTransactionId: number;

  constructor(
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private _router: Router
  ) { }

  ngOnInit(): void {

    this.formTransactionId =
      Number(
        this.route.snapshot.paramMap.get(
          'formTransactionId'
        )
      );
  }

  goHome() {
    this.globalService.clearCurCache = false;
    this._router.navigate(['/home']);
  }  
}